<template>
  <c-modal
    class-name="profile-field-modal"
    :active="displayModal"
    :title="title"
    :disable-scroll="disableScroll"
    @close="close"
  >
    <template #subtitle>
      <div v-if="field && field.isSystem" class="system-label">Системное</div>
    </template>

    <div class="field-form">
      <div class="form-group field-form__tab">
        <c-input v-model="tab" type="select" label="Вкладка" :searchable="true" :items="tabsList" />
      </div>

      <div v-if="!field" class="form-group field-form__creation-type">
        <c-switcher v-model="creationType" type="group" class="h-switcher" :items="creationTypes" />
      </div>

      <component
        :is="activeForm"
        ref="form"
        :profile-id="profileId"
        :field="field"
        :fields="fields"
        :save-field-data="saveFieldData"
        :save-dictionary="saveDictionary"
        @submitted="onSubmit"
        @pending="pending = $event"
      />
    </div>

    <template #actions>
      <c-button size="large" label="Отменить" @click="close" />
      <c-button label="Сохранить" color="primary" size="large" :disabled="pending" :pending="pending" @click="submit" />
    </template>
  </c-modal>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import CSwitcher from "@/components/controls2/Switcher";
import CModal from "@/components/scrollable-modal";

import CustomFieldForm from "../components/CustomFieldForm";
import SystemFieldForm from "../components/SystemFieldForm/index";
import FromCreatedForm from "../components/FromCreatedForm";

import { Breakpoint } from "@/utils/browser/breakpoint";

export default {
  components: {
    CInput,
    CButton,
    CustomFieldForm,
    SystemFieldForm,
    CSwitcher,
    CModal,
  },
  props: ["tabs", "profileId", "fields"],
  data() {
    return {
      displayModal: false,
      isSubmitted: false,
      pending: false,

      disableScroll: true,
      breakpoint: null,

      creationTypes: [
        { label: "Создать новое", value: "custom" },
        { label: "Выбрать из созданных", value: "existing" },
        { label: "Системное", value: "system" },
      ],

      field: null,
      currentTab: null,
      tab: null,

      creationType: "custom",
    };
  },
  computed: {
    activeForm() {
      if (this.creationType === "existing") return FromCreatedForm;
      if (this.creationType === "system") return SystemFieldForm;
      return CustomFieldForm;
    },
    title() {
      return this.field ? "Редактировать поле" : "Добавить поле";
    },

    tabsList() {
      return this.tabs.map((tab) => ({ value: tab.id, label: tab.name }));
    },
  },

  created() {
    this.breakpoint = Breakpoint("(min-width: 700px)");
    const cb = (isDesktop) => {
      this.disableScroll = isDesktop;
    };
    this.breakpoint.subscribe(cb);
  },

  beforeUnmount() {
    this.breakpoint.dispose();
    this.breakpoint = null;
  },

  methods: {
    open(field, tabId) {
      this.reset();
      
      if (field) {
        this.field = field;

        if (this.field.isSystem) {
          this.creationType = "system";
        }

        if (tabId) {
          this.currentTab = tabId;
          this.tab = { value: tabId };
        }
      } else {
        const [defaultTab] = this.tabsList;
        this.tab = defaultTab;
      }
      this.displayModal = true;
    },

    close() {
      this.displayModal = false;
      this.$emit("close");
    },

    reset() {
      this.pending = false;
      this.field = null;
      this.currentTab = null;
      this.creationType = "custom";
    },

    submit() {
      this.$refs.form.submit();
    },

    saveFieldData(params) {
      params.profile_tab_id = this.tab.value;

      const editMode = !!this.field;

      if (editMode) {
        params.id = this.field.id;
      }

      const action = editMode ? "profile/updateField" : "profile/createField";

      return this.$store.dispatch(action, params);
    },

    saveDictionary(params) {
      return this.$store.dispatch("profile/updateDictionary", params);
    },

    onSubmit(model) {
      const editMode = !!this.field;

      this.$notify({
        group: "success-message",
        data: {
          textMessage: editMode
            ? `Поле <b>${model.name}</b> успешно изменено`
            : `Поле <b>${model.name}</b> успешно добавлено`,
        },
      });
      this.$emit(editMode ? "updated" : "created", {
        field: model,
        tabId: this.tab.value,
        oldTabId: this.currentTab,
      });
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.field-form {
  &__tab {
    padding-top: 6px;
  }
}
.system-label {
  color: $color-label;
  font-size: 13px;
}
</style>

<style>
.profile-field-modal {
  max-width: 590px !important;
}
</style>
<style>
.field-form .field-form__name .c-input-floating-label {
  min-width: 142px!important;
}
</style>